module.exports = __webpack_public_path__ + "static/media/giftsSent_3000_5000.00aa8b1b.png";